import * as React from 'react'
import * as ReactDOM from 'react-dom/client'
import { HandleReactComponentRendering } from '@ClientBase/React/RenderReactComponents'
import { declareClientPackage, RuntimeDetails } from '@ClientBase/IClientPackage'
import { JobFiltersEventHandler } from '@ClientBase/Generic/JobFiltersEventHandler'
import { PostFiltersEventHandler } from '@ClientBase/Generic/PostFiltersEventHandler'
import { BurgerMenuEventHandler } from '@ClientBase/Generic/BurgerMenuEventHandler'
import { CreateCarousels } from './Carousels'
import * as VideoSnippet from './VideoSnippet'
import * as DomMainipulations from './DomMainipulations'
import * as Navigation from './Navigation'
import * as SiteSwitcher from './SiteSwitcher'
import * as SearchOverlay from './SearchOverlay'
import * as JobFilters from './JobFilters'
import * as StickyApply from './StickyApply'
import * as JobTile from './JobTile'
import * as Modal from './Modal'
import * as PostTile from './PostTile'
import * as ListWidget from './ListWidget'
import * as SocialProfile from './SocialProfileWidget'
import * as Footer from './Footer/Footer'
import * as Animations from './Animations/Animations'
import SnippetSpacer from './Spacer/Spacer'
import SnippetHeading from './Heading/Heading'
import SnippetContent from './Content/Content'
import SnippetImageContent from './ImageContent/ImageContent'
import SnippetContentColumn from './ContentColumn/ContentColumn'
import SnippetLinkBox from './LinkBox/LinkBox'
import SnippetTabSwitcher from './TabSwitcher/TabSwitcher'
import SnippetAccordion from './Accordion/Accordion'
import SnippetContentGrid from './ContentGrid/ContentGrid'
import SnippetVideo from './Video/Video'
import SnippetStats from './Stats/Stats'
import SnippetVideoCarousel from './VideoCarousel/VideoCarousel'
import SnippetQuotesCarousel from './QuotesCarousel/QuotesCarousel'
import SnippetJobDetailsVideo from './JobDetailsVideo/JobDetailsVideo'


/**
 * Extend the ClientBase class so you can benefit from any event hooks that Attrax offers,
 * and so that Attrax knows you have defined specific methods
 */

const _Components = {
    'SnippetSpacer': SnippetSpacer,
    'SnippetHeading': SnippetHeading,
    'SnippetContent' : SnippetContent,
    'SnippetImageContent': SnippetImageContent,
    'SnippetContentColumn': SnippetContentColumn,
    'SnippetLinkBox': SnippetLinkBox,
    'SnippetTabSwitcher': SnippetTabSwitcher,
    'SnippetAccordion': SnippetAccordion,
    'SnippetContentGrid': SnippetContentGrid,
    'SnippetVideo': SnippetVideo,
    'SnippetStats': SnippetStats,
    'SnippetVideoCarousel': SnippetVideoCarousel,
    'SnippetQuotesCarousel': SnippetQuotesCarousel,
    'SnippetJobDetailsVideo': SnippetJobDetailsVideo,
}

declareClientPackage({
    onCmsSnippetPreview() {
        HandleReactComponentRendering(React, ReactDOM, _Components)
    },
    onDocumentReady(details: RuntimeDetails) {
        HandleReactComponentRendering(React, ReactDOM, _Components)
        Navigation.navigationFunctions()
        SiteSwitcher.initialise()
        DomMainipulations.removeSocialWidgetIfEmpty()
        JobFiltersEventHandler.useAttraxTsHandlers($)
        PostFiltersEventHandler.useAttraxTShandler($)
        BurgerMenuEventHandler.handleClickEvents($)
        VideoSnippet.VideoClickHandler()
        DomMainipulations.moveLinkedInButton($)
        DomMainipulations.injectJsResource($)
        DomMainipulations.repositionBioModal($)
        DomMainipulations.showValidationIfTrue($)
        DomMainipulations.createStickyApplyHeading($)
        DomMainipulations.moveKeyword()
        DomMainipulations.moveSendCvModal($)
        DomMainipulations.removeFooterAutocomplete($)
        DomMainipulations.displayNoSavedJobsMessage($)
        DomMainipulations.showExpiredVacancyBanner($)
        DomMainipulations.addClearbtn()
        DomMainipulations.removeNonBreakingSpaceFromJobDetails()
        DomMainipulations.postResultsMoveTotalResults()
        DomMainipulations.showAuthorDetailsIfAuthor()
        CreateCarousels()
        JobFilters.initialise()
        StickyApply.showStickyApply()
        JobTile.addLogo()
        JobTile.logoReplacer()
        JobTile.brandClassAssignment()
        JobTile.setActive()
        JobTile.flagEmptySalaryValues()
        Modal.closeModalOnBgClick()
        PostTile.makePostTileClickable()
        ListWidget.checkIfJobTilesHaveProfile()
        SocialProfile.displayRecruiterIfAvailable()
        Footer.initialise()
        SearchOverlay.initialise()
        Animations.initialise()
        $(document).on('job-filter-initialized', function () {
            (window as any).jobFilterNoReloadController.enableDefaultFilterCounts()
            JobTile.flagEmptySalaryValues()
        })
    }
})
